﻿import document from 'document';
import { eventBus } from '../../foundation/eventBus';
import { enableFormSubmission, events as formEvents } from '../../feature/form/enable-form';
import { getAllSiblings, getChild, getElementByFilter, getNextSiblings, getPreviousSiblings } from '../../utilities/selector';
import { hasAttribute } from '../../foundation/form/validation';
import { attachEvent } from '../../utilities/events';

export const address = () => {

    const constants = {
        monthsAtaYear: 12,
        leastMonthsLimit:60,
        btnUpdateAddress: 'Update address'
    }

    const selectors = {
        root: '.form',
        searchField: '.js-address-lookup',
        field: '.form-field-group__address-label',
        addressField: '.form-field-group__input-address',
        addressList: 'js-address-list',
        searchButton: '.find-address-btn',
        resultsContainer: '.address-search',
        errorMessage: '.form-field-group__error',
        warningMessageLocation: '.form-section',
        warningMessage: '.form-field-group__warningMessage',
        manualAddressButton: '.manual-address-link',
        hiddenFieldToggle: 'form-field-group__hidden-fields',
        visibleFieldToggle: 'form-field-group__hidden-fields--visible',
        addressData: 'address-data',
        addressContainer: 'address-container',
        formEditAddress: 'form-edit-address',
        formInput: '.form-field-group__input',
        btnCancel: 'btnCancel',
        addressForm:'address-form',
        editAddressLink:'edit-address',
        editAddressHeading:'edit-address-heading',
        btnAddUpdateAddress:'btnUpdateAddress',
        mainContainer: '.form-field-group--address',
        yearsAtAddress:'YearsAtAddress',
        monthsAtAddress:'MonthsAtAddress',
        previousAddressContainer:'previous-address-container',
        newPreviousAddress:'new-previous-address',
        currentAddress:'current-address',
        previousAddressesListContainer:'previous-addresses-list',
        skipValidation:'skip-validation',
        yearsAtMonthsAtAddress:'#YearsAtMonthsAtAddress',
        buildingNote: '#BuildingNote',
        houseValidationMessage:'#HouseValidationMessage',
        houseName: '#HouseName',
        houseNumber: '#HouseNumber',
        flat: '#Flat',
        addressValidationMessage: '#AddressValidationMessage',
        street: '#Street',
        town: '#Town',
        postCode: '#Postcode',
        county: '#County',
        timeAtAddressNoteTemplate: '#TimeAtAddressNoteTemplate',
        timeAtAddressNote: '#TimeAtAddressNote',
        populatedCompanyName: '#AddressCompanyName',
        populatedHouseName: '#AddressHouseName',
        populatedHouseNumber: '#AddressHouseNumber',
        populatedFlat: '#AddressFlat',
        populatedStreet: '#AddressStreet',
        populatedTown: '#AddressTown',
        populatedPostCode: '#AddressPostalCode',
        populatedCounty: '#AddressCounty',
        ariaInvalidAttribute: 'aria-invalid'
    };

    var config = {};

    var _makeRequest = function (service, dataObj, func)
    {
        service.url += '?' + ( new URLSearchParams( dataObj ) ).toString();
        var method = 'GET'
        let options = {
            method
        };
        fetch(service.url, options)
        .then((response) => response.json())
        .then((result) => {
            if (result.Items && result.Items[0].Error) {
                var dataMessage = result.Items[0];
                console.warn(`Error: ${dataMessage.Error}, ${dataMessage.Description}, ${dataMessage.Cause}, ${dataMessage.Resolution}`);
            }
            else
            {
                if (typeof func != 'function')
                {
                    console.warn(func + ' is not a function');
                }
                else
                {
                    func(result);
                }
            }
        })
        .catch((error) => {
            console.warn('Error:', error);
        });
    };

    var _findAddress = function (text, currentNode) {
        if (text != null || text != '') {
            var findArr = [
                {
                    url: config.findService
                },
                {
                    key: config.key,
                    text: text,
                    countries: config.country // this can be GB (single) or GB, US, CA
                },
                function (data) {
                    _findListOfAddress(data, currentNode);
                }
            ];
            _makeRequest.apply(null, findArr);
        }
    };

    var _findListOfAddress = function (data, currentNode) {

        if (data.Items.length) {
            var item = data.Items[0];
            if (item.Type === "Postcode" || item.Type === 'BuildingNumber' || item.Type === 'Street') {
                var findArr = [
                    {
                        url: config.findService
                    },
                    {
                        key: config.key,
                        text: item.Text,
                        countries: config.country, // this can be GB (single) or GB, US, CA
                        container: item.Id // id is recieved from previous ajax request
                    },

                    function createResultList(data) {
                        var items = data.Items.map(function (suggestion) {
                            return {
                                label: suggestion.Text + ", " + suggestion.Description,
                                value: '',
                                data: suggestion
                            };
                        });

                        _createHtmlResultsContainer(items, currentNode);
                    }
                ];
                _makeRequest.apply(null, findArr);
            } else {
                var items = data.Items.map(function (suggestion) {
                    return {
                        label: suggestion.Text + ", " + suggestion.Description,
                        value: '',
                        data: suggestion
                    };
                });
                _createHtmlResultsContainer(items, currentNode);
            }
        }
    };

    var _retrieveAddress = function (id, resultsContainer) {
        if (id != null || id != '') {
            var retrieveArr = [
                {
                    url: config.receiveService
                },
                {
                    key: config.key,
                    id: id,
                    field1format: config.customfield
                },
                function clearResults(data) {
                    if (data.Items.length) {
                        _clearResultsContainer(resultsContainer);
                        _hideAddressSearch(resultsContainer.parentElement);
                        _populateAddress(data, resultsContainer.parentElement);
                        _showAddressData(resultsContainer.parentElement);
                    }
                }
            ];
            _makeRequest.apply(null, retrieveArr);
        }
    };

    var _createHtmlResultsContainer = function (resultItems, currentNode) {
        var resultsContainerList = getAllSiblings(currentNode, selectors.resultsContainer);
        if(resultsContainerList && resultsContainerList.length > 0) {
            if (resultItems.length) {
                resultsContainerList[0].innerHTML = `<ul class="address-search__results ${selectors.addressList} " size="4" />`;
                _createHtmlResultsList(resultItems, resultsContainerList[0].children[0]);
            }
            else
            {
                resultsContainerList[0].innerHTML = '<div class="address-search__no-results">Sorry no results found.</div>';
            }
        }
    };

    var _clearResultsContainer = function (resultsContainer) {
        resultsContainer.innerHTML = '';
    };

    var _createHtmlResultsList = function (items, resultNode) {
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var label = item.label;
            var itemNext = item.data.Next;
            var itemId = item.data.Id;

            if (resultNode) {
                resultNode.insertAdjacentHTML('beforeend','<li class="address-search__result-item" data-value="' + label + '" title="' + label + '" data-next="' + itemNext + '" data-id="' + itemId + '"><span>' + label + '</span></li>');
            }
        }
    };

    var _hideAddressSearch = function (parentElement) {
        var addressInput = getChild(parentElement,selectors.addressField);
        var addressButton = getChild(parentElement,selectors.searchButton);
        var enterManually = getNextSiblings(parentElement,selectors.manualAddressButton);

        if (addressInput && !addressInput.classList.contains(selectors.hiddenFieldToggle)) {
            addressInput.classList.add(selectors.hiddenFieldToggle);
        }
        if (addressButton && !addressButton.classList.contains(selectors.hiddenFieldToggle)) {
            addressButton.classList.add(selectors.hiddenFieldToggle);
        }
        if (enterManually && enterManually.length > 0  && !enterManually[0].classList.contains(selectors.hiddenFieldToggle)) {
            enterManually[0].classList.add(selectors.hiddenFieldToggle);
        }
    };

    var _showAddressData = function (parentElement) {
        var addressDataContainer = getChild(parentElement,`#${selectors.addressData}`);

        if (addressDataContainer) {
            addressDataContainer.style.display = null;
        }
    };

    var _removeEnterManualField = function () {
        document.querySelector(selectors.manualAddressButton).innerHTML = '';
    };

    function clearChildren(element) {
        for (var i = 0; i < element.childNodes.length; i++) {
            const e = element.childNodes[i];
            if (e.tagName) switch (e.tagName.toLowerCase()) {
                case 'input':
                    switch (e.type) {
                        case "radio":
                        case "checkbox": e.checked = false; break;
                        case "button":
                        case "submit":
                        case "image": break;
                        default: e.value = ''; break;
                    }
                    break;
                case 'select': e.selectedIndex = 0; break;
                case 'textarea': e.innerHTML = ''; break;
                default: clearChildren(e);
            }
        }
    }

    // Changes building note's visibility
    function changeBuildingNoteVisibility(isVisible) {
        const buildingNote = getElementByFilter(selectors.buildingNote);

        if (buildingNote) {
            if (isVisible) {
                 // display building note not validation
                buildingNote.classList.add("visible");
                buildingNote.classList.remove("hidden");
            } else {
                 // display validation not building note
                buildingNote.classList.remove("visible");
                buildingNote.classList.add("hidden");
            }
        }
    }

    // Clear all validation messages and styles
    function clearValidations(element) {
        if (element) {
            const allValidations = element.querySelectorAll(selectors.errorMessage);
            const allInputs = element.querySelectorAll(selectors.formInput);
            for (var key = 0; key < allValidations.length; key++) {
                allValidations[key].classList.remove('visible');
            }
            for (var i = 0; i < allInputs.length; i++) {
                allInputs[i].removeAttribute(selectors.ariaInvalidAttribute);
            }
            changeBuildingNoteVisibility(true);

            const houseValidation = getElementByFilter(selectors.houseValidationMessage);
            if(houseValidation) {
                const houseName = getElementByFilter(selectors.houseName);
                const houseNumber = getElementByFilter(selectors.houseNumber);
                const houseFlat = getElementByFilter(selectors.flat);
                houseValidation.classList.remove("visible");
                houseName.removeAttribute(selectors.ariaInvalidAttribute);
                houseNumber.removeAttribute(selectors.ariaInvalidAttribute);
                houseFlat.removeAttribute(selectors.ariaInvalidAttribute);
                const buildingNote = getElementByFilter(selectors.buildingNote);

                // display validation not building note
                if (buildingNote) {
                    buildingNote.classList.add("hidden");
                    buildingNote.classList.remove("visible");
                }
            }
        }
    }

    // this function creates GUID in javascript
    function uuidv4() {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    var _populateAddress = function (data, parentElement) {
        var addressDataContainer = getChild(parentElement,`#${selectors.addressData}`);

        if (addressDataContainer) {
            const fields = addressDataContainer.querySelectorAll(selectors.field);
            var addressKeys = Object.keys(data.Items[0]);
            for (var key = 0; key < addressKeys.length; key++) {
                [...fields].filter(getItemAttribute);

                function getItemAttribute(item){
                    var itemAttr = item.getAttribute('data-address-key');
                    if (itemAttr === addressKeys[key]) {
                        if (item.tagName.toLowerCase() === 'input') {
                            item.value = data.Items[0][itemAttr];
                        } else {
                            item.innerText = data.Items[0][itemAttr];
                            if(!data.Items[0][itemAttr]) {
                                item.classList.add("hidden");
                            }
                        }
                        item.removeAttribute(selectors.ariaInvalidAttribute);
                    }
                }
            }
            const addressValidation =getPreviousSiblings(addressDataContainer, selectors.addressValidationMessage);
            if(addressValidation && addressValidation.length > 0) {
                addressValidation[0].classList.remove("visible");
            }
        }
    };

    function setSliderInputsValue (addressDataContainer, fromSelector, targetSelector) {
        const fromElement = getChild(addressDataContainer, fromSelector);
        if(fromElement) {
            const targetElement = getElementByFilter(targetSelector);
            targetElement.value = fromElement.value;
        }
    }

    function setSliderFlatValue(addressDataContainer) {
        const CompanyName = getChild(addressDataContainer, selectors.populatedCompanyName);
        const AddressFlat = getChild(addressDataContainer, selectors.populatedFlat);

        if (CompanyName || AddressFlat) {
            const names = [CompanyName.value, AddressFlat.value]
            const flat = getElementByFilter(selectors.flat);
            flat.value = names.filter(Boolean).join(", ");
        }
    }

    function setAddressSliderData(mainAddressContainer) {

        let mainContainerId = mainAddressContainer.getAttribute('id');
        let addressType = mainAddressContainer.getAttribute('data-address-type');

        const containerSelf= document.getElementById(mainContainerId);
        const addAddressData= getChild(containerSelf, `#${selectors.addressData}`);
        if (addAddressData && containerSelf) {
            setSliderFlatValue(addAddressData);
            setSliderInputsValue(addAddressData, selectors.populatedHouseName, selectors.houseName);
            setSliderInputsValue(addAddressData, selectors.populatedHouseNumber, selectors.houseNumber);
            setSliderInputsValue(addAddressData, selectors.populatedStreet, selectors.street);
            setSliderInputsValue(addAddressData, selectors.populatedTown, selectors.town);
            setSliderInputsValue(addAddressData, selectors.populatedCounty, selectors.county);
            setSliderInputsValue(addAddressData, selectors.populatedPostCode, selectors.postCode);
            setSliderInputsValue(addAddressData, selectors.populatedFlat, selectors.flat);
        }
        const addAddressForm= document.getElementById(selectors.addressContainer);
        // set current data to slider and display slider from right
        if (addAddressForm && containerSelf) {
            const addAddressTitle= document.getElementById(selectors.editAddressHeading);
            const buttonUpdateAdd = document.getElementById(selectors.btnAddUpdateAddress);
            addAddressTitle.innerText = `Update ${addressType} address`;
            buttonUpdateAdd.value = constants.btnUpdateAddress;
            addAddressForm.style.display = "block";
            document.body.style.overflow = 'hidden';
            addAddressForm.setAttribute("data-container-id", mainContainerId);
            setTimeout(function(){
                var addressForm = document.getElementsByClassName(selectors.formEditAddress)[0];
                if (addressForm) {
                    addressForm.style.right = 0;
                }
            });

            enableFormSubmission().init(addAddressForm);
        }
    }

    function calculateTotalMonths(){
        let totalMonths = 0;

        //#region Current Address
        const currentAddressYearsAt = document.querySelector(`#${selectors.currentAddress} input[id="${selectors.yearsAtAddress}"]`);
        const currentAddressMonthsAt = document.querySelector(`#${selectors.currentAddress} input[id="${selectors.monthsAtAddress}"]`);
        if(currentAddressYearsAt && currentAddressMonthsAt) {
            totalMonths = (Number(currentAddressYearsAt.value) * constants.monthsAtaYear) + Number(currentAddressMonthsAt.value);
        }
        //#endregion
        //#region PreviousAddressesList
        const previousAddressesList = document.getElementById(selectors.previousAddressContainer);
        if(previousAddressesList) {
            const allYears = document.querySelectorAll(`#${selectors.previousAddressContainer} input[id^="${selectors.yearsAtAddress}"]`);
            const allMonths = document.querySelectorAll(`#${selectors.previousAddressContainer} input[id^="${selectors.monthsAtAddress}"]`);

            for (let i = 0; i < allYears.length; i++) {
                totalMonths+=((Number(allYears[i].value) * constants.monthsAtaYear) + Number(allMonths[i].value));
            }
        }
        //#endregion

        return totalMonths;
    }

    function configureYearsMonths (element, selector, isTemplate,id) {
        if(element){
            if(isTemplate) {
                element.removeAttribute("required");
                element.setAttribute(selectors.skipValidation, "true");
            } else {
                element.setAttribute('required', "true");
                element.setAttribute('id', `${selector}_${id}`);
                element.removeAttribute(selectors.skipValidation);
                element.removeAttribute(selectors.ariaInvalidAttribute);
                const errorMessage = getNextSiblings(element,selectors.errorMessage);
                element.classList.add(selector);

                if(errorMessage && errorMessage.length > 0) {
                    errorMessage[0].classList.remove('visible');
                }
            }
        }
    }

    function enableFormSubmit() {
        const components = document.querySelectorAll(selectors.root);
        if (components) {
            [...components].forEach(component => {
                enableFormSubmission().init(component);
            });
        }
    }

    function addNewAddressSection(template, data = null) {
        let clone = template.cloneNode( true );
        clone.setAttribute( 'id', selectors.newPreviousAddress);
        clone.style.display = null;
        clone.style.width = '100%';

        const firstChild = getChild(clone,selectors.mainContainer);

        if(!firstChild) {
            return;
        }

        firstChild.setAttribute( 'id', uuidv4());
        firstChild.setAttribute( 'data-required', "true");
        const findAddressButton =  getChild(firstChild, selectors.searchButton);
        if(findAddressButton) {
                findAddressButton.addEventListener('click', function(e){
                    e.preventDefault();
                    var inputValueList = getAllSiblings(findAddressButton,selectors.searchField);
                    if (inputValueList.length > 0) {
                        _findAddress(inputValueList[0].value, inputValueList[0]);
                    }
                });
        }

        const addressSearch =  getChild(firstChild, selectors.resultsContainer);
        if(addressSearch){
                addressSearch.addEventListener('click', function(e){
                    e.preventDefault();
                    if(e.target && e.target.nodeName === 'SPAN') {
                        var itemSelectedAttribute = e.target.parentElement.getAttribute('data-id');
                        _retrieveAddress(itemSelectedAttribute,addressSearch);
                    }
                });
        }

        const addressData =  getChild(firstChild, `#${selectors.addressData}`);

        if(!addressData){
            return;
        }

        const editAddressLink =  getChild(addressData, `#${selectors.editAddressLink}`);
        if(editAddressLink){
            editAddressLink.addEventListener('click', function(e){
                e.preventDefault();
                const mainAddressContainer = e.target.closest(selectors.mainContainer);
                changeBuildingNoteVisibility(true);

                if(mainAddressContainer){
                    setAddressSliderData(mainAddressContainer);
                }

            });
        }

        const manualAddressButton =  getChild(clone, selectors.manualAddressButton);
        if(manualAddressButton){
            manualAddressButton.addEventListener('click', function(e){
                e.preventDefault();
                var mainContainerId;
                var addressType;
                changeBuildingNoteVisibility(true);
                const addressMainContainer = getPreviousSiblings(e.target,selectors.mainContainer );
                if(addressMainContainer && addressMainContainer.length > 0){
                    mainContainerId = addressMainContainer[0].getAttribute('id');
                    addressType = addressMainContainer[0].getAttribute('data-address-type');
                }
                const addAddressForm= document.getElementById(selectors.addressContainer);
                if (addAddressForm && addressMainContainer) {
                    addAddressForm.style.display = "block";
                    document.body.style.overflow = 'hidden';
                    addAddressForm.setAttribute("data-container-id", mainContainerId);
                    const addAddressTitle= document.getElementById(selectors.editAddressHeading);
                    addAddressTitle.innerText = `Add ${addressType} address`;

                    setTimeout(function(){
                        var addressForm = document.getElementsByClassName(selectors.formEditAddress)[0];
                        if (addressForm) {
                            addressForm.style.right = 0;
                        }
                    });

                    enableFormSubmission().init(addAddressForm);

                }
            });
        }

        const addressAtYears = getChild(clone,`#${selectors.yearsAtAddress}`);
        configureYearsMonths(addressAtYears,selectors.yearsAtAddress,false,firstChild.id);

        const addressAtMonths = getChild(clone,`#${selectors.monthsAtAddress}`);
        configureYearsMonths(addressAtMonths, selectors.monthsAtAddress,false,firstChild.id);

        const totalMonths = calculateTotalMonths();
        const restMonths = (Number(constants.leastMonthsLimit) - Number(totalMonths));
        const templateNote = getElementByFilter(selectors.timeAtAddressNoteTemplate);
        const year = Math.floor(restMonths / constants.monthsAtaYear);
        const months = restMonths % constants.monthsAtaYear;
        const finalNoteYears = year>0? `${year} years` : '';
        const finalNoteMonths = months>0?` ${year?',':''} ${months} months` : '';
        const parent = addressAtYears.closest(selectors.yearsAtMonthsAtAddress)
        const childNote = getChild(parent, selectors.timeAtAddressNote);
        if(childNote) {
            childNote.innerText = replaceStringWithParamaters(templateNote.value, `${finalNoteYears} ${finalNoteMonths}`);
        }

        document.getElementById(selectors.previousAddressContainer).appendChild( clone );
        enableFormSubmit();

        if (data != null) {
            addressAtYears.value = data.Items[0].YearsAtAddress;
            addressAtMonths.value = data.Items[0].MonthsAtAddress;
            _populateAddress(data, firstChild);
            _hideAddressSearch(firstChild);
            _showAddressData(firstChild);
        }
    }

    function addPreviousAddresses() {
        const previousAddressData = window.previousAddresses;

        const previousAddressesListContainer = document.getElementById(selectors.previousAddressesListContainer);

        if (previousAddressesListContainer) {
            previousAddressesListContainer.style.display = null;
        }

        const newPreviousAddressTemplate = document.getElementById(`${selectors.newPreviousAddress}-template`);
        if (newPreviousAddressTemplate)
        {
            _makeAddressMonthYearsNotRequired(newPreviousAddressTemplate);

            for (let addr = 0; addr < previousAddressData.length; addr++) {
                //add previous addresses
                addNewAddressSection(newPreviousAddressTemplate, previousAddressData[addr]);
            }

            bindPreviousAddressEvents();
        }
    }

    function bindPreviousAddressEvents() {
        const allYears = document.querySelectorAll(`#${selectors.previousAddressContainer} input[id^="${selectors.yearsAtAddress}"]`);
        const allMonths = document.querySelectorAll(`#${selectors.previousAddressContainer} input[id^="${selectors.monthsAtAddress}"]`);

        for (let i = 0; i < allYears.length; i++) {
            if (allYears[i]) {
                attachEvent(allYears[i], 'change', calculateAllAddresses);
            }
        }

        for (let i = 0; i < allMonths.length; i++) {
            if (allMonths[i]) {
                attachEvent(allMonths[i], 'change', calculateAllAddresses);
            }
        }

        const allAddressesSections = document.querySelectorAll(`#${selectors.previousAddressContainer} #${selectors.newPreviousAddress}`);

        for (let i = 0; i < allAddressesSections.length; i++) {
            const inputs = allAddressesSections[i].getElementsByTagName('input');
            for (let index = 0; index < inputs.length; ++index) {
                if (inputs[index].id.indexOf('_') > -1) {
                    inputs[index].setAttribute('name', `PreviousAddresses[${i}].${inputs[index].id.slice(0, inputs[index].id.lastIndexOf("_"))}`);
                } else {
                    inputs[index].setAttribute('name', `PreviousAddresses[${i}].${inputs[index].id}`);
                }
            }
        }
    }

    function managePreviousAddress() {
        const previousAddressesListContainer = document.getElementById(selectors.previousAddressesListContainer);
        if(previousAddressesListContainer) {
            previousAddressesListContainer.style.display = null;
        }
        const newPreviousAddressTemplate = document.getElementById(`${selectors.newPreviousAddress}-template`);
        if(newPreviousAddressTemplate) {
            _makeAddressMonthYearsNotRequired(newPreviousAddressTemplate);

            // this code block checks if there is already added new address section with no value if so no new section is added
            const newPreviousAddressList = document.querySelectorAll(`#${selectors.newPreviousAddress}`);
            if(newPreviousAddressList.length === 0){
                addNewAddressSection(newPreviousAddressTemplate);
            } else {
                let addNew=true;
                for (let i = 0; i < newPreviousAddressList.length; i++) {
                    const atYear=getChild(newPreviousAddressList[i],`.${selectors.yearsAtAddress}`);
                    const atMonth=getChild(newPreviousAddressList[i],`.${selectors.monthsAtAddress}`);
                    if(Number(atYear.value) ===0 && Number(atMonth.value) ===0 ){
                        addNew=false;
                    }
                }
                if(addNew){
                    addNewAddressSection(newPreviousAddressTemplate);
                }
            }
            bindPreviousAddressEvents();
        }
    }

    function clearPreviousAddress() {
        const previousAddressesListContainer = document.getElementById(selectors.previousAddressesListContainer);
        if(previousAddressesListContainer) {
            clearChildren(previousAddressesListContainer);
            previousAddressesListContainer.style.display = "none";
        }
        const previousAddressContainer = document.getElementById(selectors.previousAddressContainer);
        if(previousAddressContainer) {
            previousAddressContainer.innerHTML = '';
        }
    }

    const replaceStringWithParamaters = (text, ...args) => text.replace(/(\{\d+\})/g, a => args[+(a.substr(1, a.length - 2)) || 0] );

    function calculateAllAddresses() {
        let totalMonths = 0;

        //#region Current Address
        const currentAddressYearsAt = document.querySelector(`#${selectors.currentAddress} input[id="${selectors.yearsAtAddress}"]`);
        const currentAddressMonthsAt = document.querySelector(`#${selectors.currentAddress} input[id="${selectors.monthsAtAddress}"]`);
        if(currentAddressYearsAt && currentAddressMonthsAt) {
            totalMonths = (Number(currentAddressYearsAt.value) * constants.monthsAtaYear) + Number(currentAddressMonthsAt.value);
        }
        //#endregion

        if (constants.leastMonthsLimit === totalMonths || totalMonths > constants.leastMonthsLimit) {
            clearPreviousAddress();
            enableFormSubmit();
            return;
        }

        let restMonths = (Number(constants.leastMonthsLimit) - Number(totalMonths));

        //#region PreviousAddressesList
        const previousAddressesList = document.getElementById(selectors.previousAddressContainer);
        if(previousAddressesList) {
            const allYears = document.querySelectorAll(`#${selectors.previousAddressContainer} input[id^="${selectors.yearsAtAddress}"]`);
            const allMonths = document.querySelectorAll(`#${selectors.previousAddressContainer} input[id^="${selectors.monthsAtAddress}"]`);
            let clearNextPreviousAddresses=false;

            for (let i = 0; i < allYears.length; i++) {
                if (clearNextPreviousAddresses){
                    const parent = allYears[i].closest(`#${selectors.newPreviousAddress}`);
                    if(parent){
                        parent.remove();
                    }
                }

                const templateNote = getElementByFilter(selectors.timeAtAddressNoteTemplate);
                const year = Math.floor(restMonths / constants.monthsAtaYear);
                const months = restMonths % constants.monthsAtaYear;
                const finalNoteYears = year>0? `${year} years` : '';
                const finalNoteMonths = months>0?` ${year?',':''} ${months} months` : '';
                const parent = allYears[i].closest(selectors.yearsAtMonthsAtAddress);

                const childNote = getChild(parent, selectors.timeAtAddressNote);
                if(childNote) {
                    childNote.innerText = replaceStringWithParamaters(templateNote.value, `${finalNoteYears} ${finalNoteMonths}`);
                }

                totalMonths+=((Number(allYears[i].value) * constants.monthsAtaYear) + Number(allMonths[i].value));
                restMonths = (Number(constants.leastMonthsLimit) - Number(totalMonths));
                if (constants.leastMonthsLimit === totalMonths || totalMonths > constants.leastMonthsLimit) {
                    clearNextPreviousAddresses= true;
                }
            }
        }
        //#endregion

        if (0 < totalMonths && totalMonths < constants.leastMonthsLimit) {
            managePreviousAddress();
        }
    }

    function setAddressHiddenInputsAndLabels(addressDataContainer, targetSelector, value, parentContainer) {
        const targetElement = getChild(addressDataContainer, targetSelector);
        if(targetElement) {
            targetElement.value = value;
            const targetElementLabel= getChild(parentContainer ? parentContainer : addressDataContainer, `${targetSelector}Label`);
            if(targetElementLabel) {
                targetElementLabel.innerText = value;
                if (!value) {
                    targetElementLabel.classList.add("hidden");
                } else {
                    targetElementLabel.classList.remove("hidden");
                }
            }
        }
    }

    var _bindEvents = function () {

        const currentAddressYearsAt = document.querySelector(`#${selectors.currentAddress} input[id="${selectors.yearsAtAddress}"]`);
        const currentAddressMonthsAt = document.querySelector(`#${selectors.currentAddress} input[id="${selectors.monthsAtAddress}"]`);

        if(currentAddressYearsAt) {
            currentAddressYearsAt.addEventListener('change', function(){
                calculateAllAddresses();
            });
        }

        if(currentAddressMonthsAt) {
            currentAddressMonthsAt.addEventListener('change', function(){
                calculateAllAddresses();
            });
        }

        const searchButtonList = document.querySelectorAll(selectors.searchButton);
        if(searchButtonList.length && searchButtonList.length > 0){
            for (let i = 0; i < searchButtonList.length; i++) {
                searchButtonList[i].addEventListener('click', function(e){
                    e.preventDefault();
                    var inputValueList = getAllSiblings(searchButtonList[i],selectors.searchField);
                    if (inputValueList.length > 0) {
                        _findAddress(inputValueList[0].value, inputValueList[0]);
                    }
                });
            }
        }

        const addressSearchList = document.querySelectorAll(selectors.resultsContainer);
        if(addressSearchList.length && addressSearchList.length > 0){
            for (let i = 0; i < addressSearchList.length; i++) {
                addressSearchList[i].addEventListener('click', function(e){
                    e.preventDefault();
                    if(e.target && e.target.nodeName === 'SPAN') {
                        var itemSelectedAttribute = e.target.parentElement.getAttribute('data-id');
                        _retrieveAddress(itemSelectedAttribute,addressSearchList[i]);
                    }
            });
            }
        }

        document.addEventListener('mouseup', function(event) {
            const resultContainerList = document.querySelectorAll(`.${selectors.addressList}`);
            if(resultContainerList.length && resultContainerList.length > 0){
                for (let i = 0; i < resultContainerList.length; i++) {
                    if(resultContainerList[0] && !resultContainerList[0].contains(event.target)){
                        _clearResultsContainer(resultContainerList[0]);
                    }
                }
            }
        });

        document.addEventListener('keydown' , function(event) {
            event = event || window.event;
            const resultContainerList = document.querySelectorAll(`.${selectors.addressList}`);
            if(resultContainerList.length && resultContainerList.length > 0){
                for (let i = 0; i < resultContainerList.length; i++) {
                    if (resultContainerList[0] && event.key === 'Escape') {
                        _clearResultsContainer(resultContainerList[0]);
                    }
                }
            }
        });

        const manualAddressButtonList = document.querySelectorAll(selectors.manualAddressButton);
        if(manualAddressButtonList.length && manualAddressButtonList.length > 0){
            for (let i = 0; i < manualAddressButtonList.length; i++) {
                manualAddressButtonList[i].addEventListener('click', function(e){
                    e.preventDefault();
                    var mainContainerId;
                    var addressType;
                    changeBuildingNoteVisibility(true);
                    const addressMainContainer = getPreviousSiblings(e.target,selectors.mainContainer );
                    if(addressMainContainer && addressMainContainer.length > 0){
                        mainContainerId = addressMainContainer[0].getAttribute('id');
                        addressType = addressMainContainer[0].getAttribute('data-address-type');
                    }
                    const addAddressForm= document.getElementById(selectors.addressContainer);
                    if (addAddressForm && addressMainContainer) {
                        addAddressForm.style.display = "block";
                        document.body.style.overflow = 'hidden';
                        addAddressForm.setAttribute("data-container-id", mainContainerId);
                        const addAddressTitle= document.getElementById(selectors.editAddressHeading);
                        addAddressTitle.innerText = `Add ${addressType} address`;

                        setTimeout(function(){
                            var addressForm = document.getElementsByClassName(selectors.formEditAddress)[0];
                            if (addressForm) {
                                addressForm.style.right = 0;
                            }
                        });

                        enableFormSubmission().init(addAddressForm);

                    }
                });
            }
        }

        document.getElementById(selectors.btnCancel).addEventListener('click', function(e){
            e.preventDefault();
            var addressForm = document.getElementsByClassName(selectors.formEditAddress)[0];
            if (addressForm) {
                addressForm.style.right = '-1000px';
            }
            setTimeout(function(){
                const addAddressForm= document.getElementById(selectors.addressContainer);
                if (addAddressForm) {
                    addAddressForm.style.display = "none";
                    document.body.style.overflow = 'unset';
                    addAddressForm.setAttribute("data-container-id", "");
                    clearChildren(addAddressForm);
                    clearValidations(addAddressForm);
                }
            },500);
        });

        eventBus.subscribe(formEvents.formSubmitted, function (e) {
            if (e.id===selectors.addressForm) {
                const addAddressForm= e.event.target.closest(`#${selectors.addressContainer}`);
                const mainContainer= document.getElementById(addAddressForm.getAttribute("data-container-id"));
                const houseName= document.getElementById("HouseName");
                const houseNumber= document.getElementById("HouseNumber");
                const houseFlat= document.getElementById("Flat");
                const  isHouseValid = houseName.value || houseNumber.value || houseFlat.value;

                if(e.isValidForm && isHouseValid) {
                    var addressForm = document.getElementsByClassName(selectors.formEditAddress)[0];
                    if (addressForm) {
                        addressForm.style.right = '-1000px';
                    }
                    setTimeout(function() {
                        if (addAddressForm) {
                            addAddressForm.style.display = "none";
                            document.body.style.overflow = 'unset';
                            clearChildren(addAddressForm);
                            clearValidations(addAddressForm);
                        }
                    },500);

                    if (mainContainer) {
                        _removeEnterManualField(mainContainer);
                        _hideAddressSearch(mainContainer);
                        _showAddressData(mainContainer);
                    }
                    e.event.preventDefault();
                    const addressDataContainer = getChild(mainContainer,`#${selectors.addressData}`);
                    const addressValidation =getPreviousSiblings(addressDataContainer, selectors.addressValidationMessage);
                    if(addressValidation && addressValidation.length > 0) {
                        addressValidation[0].classList.remove("visible");
                    }
                } else {
                    e.event.preventDefault();
                }
            } else {
                    const mainContainerList = document.querySelectorAll(selectors.mainContainer);
                    if(mainContainerList.length && mainContainerList.length > 0) {
                        for (let i = 0; i < mainContainerList.length; i++) {
                            const isRequired= mainContainerList[i].getAttribute("data-required");
                            const addressInput = getChild(mainContainerList[i],"#AddressLookup");
                            const skip = hasAttribute(addressInput, 'skip-validation');
                            if(isRequired && isRequired.toLowerCase() === String(false) || skip) {
                                addressInput.setAttribute(selectors.ariaInvalidAttribute,false);
                                continue
                            }
                            addressInput.setAttribute(selectors.ariaInvalidAttribute,true);
                            const addressDataContainer=getChild(mainContainerList[i],`#${selectors.addressData}`);
                            const AddressHouseName = getChild(addressDataContainer,selectors.populatedHouseName);
                            const AddressFlat = getChild(addressDataContainer, selectors.populatedFlat);
                            const AddressHouseNumber = getChild(addressDataContainer, selectors.populatedHouseNumber);
                            const AddressStreet = getChild(addressDataContainer, selectors.populatedStreet);
                            const AddressTown = getChild(addressDataContainer,selectors.populatedTown);
                            const AddressPostalCode = getChild(addressDataContainer,selectors.populatedPostCode);
                            const  isHouseValid = AddressHouseName.value || AddressHouseNumber.value || AddressFlat.value;

                            if (!isHouseValid || !AddressStreet.value || !AddressTown.value || !AddressPostalCode.value) {
                                const addressValidation =getPreviousSiblings(addressDataContainer, selectors.addressValidationMessage);
                                if(addressValidation && addressValidation.length > 0) {
                                    addressValidation[0].classList.add("visible");
                                    e.event.preventDefault();
                                }
                            }
                        }
                    }
            }
        });

        const editAddressLinkList = document.querySelectorAll(`#${selectors.editAddressLink}`);
        if(editAddressLinkList.length && editAddressLinkList.length > 0){
            for (let i = 0; i < editAddressLinkList.length; i++) {
                editAddressLinkList[i].addEventListener('click', function(e){
                    e.preventDefault();
                    const mainAddressContainer = e.target.closest(selectors.mainContainer);
                    changeBuildingNoteVisibility(true);

                    if(mainAddressContainer){
                        setAddressSliderData(mainAddressContainer);
                    }

                });
            }
        }

        document.getElementById(selectors.btnAddUpdateAddress).addEventListener('click', function() {

            const addAddressForm= document.getElementById(selectors.addressContainer);
            var dataMainContainerId;
            if (addAddressForm) {
                dataMainContainerId = addAddressForm.getAttribute('data-container-id');
            }
            const dataMainContainer = document.getElementById(dataMainContainerId);
            const addAddressData= getChild(dataMainContainer, `#${selectors.addressData}`);
            const houseName = getElementByFilter(selectors.houseName);
            const houseNumber = getElementByFilter(selectors.houseNumber);
            const houseFlat = getElementByFilter(selectors.flat);

            const street = getElementByFilter(selectors.street);
            const streetInvalid = street.getAttribute(selectors.ariaInvalidAttribute);
            const town = getElementByFilter(selectors.town);
            const townInvalid = town.getAttribute(selectors.ariaInvalidAttribute);
            const county = getElementByFilter(selectors.county);
            const countyInvalid = county.getAttribute(selectors.ariaInvalidAttribute);
            const postcode = getElementByFilter(selectors.postCode);
            const postcodeInvalid = postcode.getAttribute(selectors.ariaInvalidAttribute);

            const houseNameInvalid = houseName.getAttribute(selectors.ariaInvalidAttribute);
            const houseNumberInvalid = houseNumber.getAttribute(selectors.ariaInvalidAttribute);
            const houseFlatInvalid = houseFlat.getAttribute(selectors.ariaInvalidAttribute);
            const isHouseValid = (houseName.value || houseNumber.value || houseFlat.value) && (houseNameInvalid !== 'true' && houseNumberInvalid !== 'true' && houseFlatInvalid !== 'true');
            const isAddressFormValid = (streetInvalid !== 'true' && townInvalid !== 'true' && countyInvalid !== 'true' && postcodeInvalid !== 'true')


            if (!isHouseValid) {
                const houseValidation = getElementByFilter(selectors.houseValidationMessage);
                if(houseValidation) {
                    houseValidation.classList.add("visible");
                    houseName.setAttribute(selectors.ariaInvalidAttribute,true);
                    houseNumber.setAttribute(selectors.ariaInvalidAttribute,true);
                    houseFlat.setAttribute(selectors.ariaInvalidAttribute,true);
                    changeBuildingNoteVisibility(false);
                }
            } else {
                if (addAddressData && isAddressFormValid) {
                    setAddressHiddenInputsAndLabels(addAddressData, selectors.populatedHouseName, houseName.value);
                    setAddressHiddenInputsAndLabels(addAddressData, selectors.populatedFlat, houseFlat.value);
                    setAddressHiddenInputsAndLabels(addAddressData, selectors.populatedTown, town.value);
                    setAddressHiddenInputsAndLabels(addAddressData, selectors.populatedCounty, county.value);
                    setAddressHiddenInputsAndLabels(addAddressData, selectors.populatedPostCode, postcode.value);

                    const AddressHouseNumberContainer= getChild(addAddressData,".form-field-group__address-label-line1");
                    if(AddressHouseNumberContainer) {
                        setAddressHiddenInputsAndLabels(addAddressData, selectors.populatedHouseNumber, houseNumber.value, AddressHouseNumberContainer);
                        setAddressHiddenInputsAndLabels(addAddressData, selectors.populatedStreet, street.value, AddressHouseNumberContainer);
                    }
                }
            }
        });
    };

    var _getSettings = function() {
        var pcaField = document.querySelector(selectors.searchField);
        var apiKey = pcaField.getAttribute('data-api-key');
        var country = pcaField.getAttribute('data-country');
        var findService = pcaField.getAttribute('data-find-service');
        var receiveService = pcaField.getAttribute('data-receive-service');
        var warningMessage = pcaField.getAttribute('data-warning-message');
        var postcodes = pcaField.getAttribute('data-postcodes');
        if (pcaField) {
            config.key = apiKey;
            config.findService = findService;
            config.receiveService = receiveService;
            config.country = country;
            config.warningmessage = warningMessage;
            config.excludedPostcodes = postcodes;
        } else {
            console.warn('no data attributes or no values for each data attributes, please check your configuration');
        }
    };

    var _makeAddressMonthYearsNotRequired = function(newPreviousAddressTemplate) {
            const addressAtYears = getChild(newPreviousAddressTemplate,`#${selectors.yearsAtAddress}`);
            configureYearsMonths(addressAtYears,selectors.yearsAtAddress,true);

            const addressAtMonths = getChild(newPreviousAddressTemplate,`#${selectors.monthsAtAddress}`);
            configureYearsMonths(addressAtMonths,selectors.monthsAtAddress,true);
    }

    var _setTemplateAddressInitialState = function() {
        const newPreviousAddressTemplate = document.getElementById(`${selectors.newPreviousAddress}-template`);
        if(newPreviousAddressTemplate) {
            _makeAddressMonthYearsNotRequired(newPreviousAddressTemplate);
        }
    }

    var init = function () {
        var root = document.querySelector(selectors.root);
        var searchField = document.querySelector(selectors.searchField);
        if (root && searchField) {
            _setTemplateAddressInitialState();
            _getSettings();
            _bindEvents();
        }

        if (window.previousAddresses && window.previousAddresses.length > 0) {
            addPreviousAddresses();
        }
    };

    return {
        init: init
    };
};